<template>
  <SubContent h="550px" @back="toCancel">
    <template v-slot:nav_left> 添加优秀苗子信息 </template>
    <div class="page-content">
      <div class="step-box">
        <!-- status: wait / process / finish / error / success -->
        <el-steps
          :active="activeStep"
          finish-status="success"
          process-status="wait"
          simple
        >
          <el-step title="评估信息"></el-step>
          <el-step title="专项评分"></el-step>
          <el-step title="主观评价"></el-step>
        </el-steps>
      </div>
      <div class="form_wrap">
        <vue-scroll>
          <div class="scroll-content form-content">
            <el-form
              :inline="false"
              ref="form"
              :model="form"
              label-width="220px"
              :rules="formRules"
            >
              <el-form-item
                label="评估时间"
                prop="scoutingTime"
                :rules="[{ required: true, message: '必填项' }]"
              >
                <el-date-picker
                  v-model="form.scoutingTime"
                  class="w380"
                  align="right"
                  type="date"
                  value-format="timestamp"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item
                label="球员姓名"
                prop="playerName"
                :rules="[{ required: true, message: '必填项' }]"
              >
                <el-input
                  v-model="form.playerName"
                  class="w380"
                  disabled
                ></el-input>
              </el-form-item>

              <el-form-item
                label="证件号"
                prop="playerIdNumber"
                :rules="[{ required: true, message: '必填项' }]"
              >
                <el-input
                  v-model="form.playerIdNumber"
                  class="w380"
                  disabled
                ></el-input>
              </el-form-item>

              <el-form-item
                label="球员出生年月"
                prop="playerBirthday"
                :data-value="form.playerBirthday"
                :rules="[{ required: true, message: '必填项' }]"
              >
                <el-date-picker
                  v-model="form.playerBirthday"
                  class="w380"
                  align="right"
                  type="date"
                  value-format="timestamp"
                  :disabled="playerUuid ? true : false"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
              <!--<el-form-item-->
                <!--label="所在队伍"-->
                <!--prop="team"-->
                <!--:rules="[{ required: true, message: '必填项' }]"-->
              <!--&gt;-->
                <!--<el-input-->
                  <!--v-model="form.team"-->
                  <!--class="w380"-->
                  <!--placeholder="请输入所在队伍"-->
                  <!--maxlength="30" show-word-limit-->
                <!--&gt;</el-input>-->
              <!--</el-form-item>-->

              <el-form-item
                label="场上主要位置"
                prop="position"
                :rules="[{ required: true, message: '必填项' }]"
              >
                <el-select
                  v-model="form.position"
                  :disabled="form.position ? true : false"
                  class="w380"
                  placeholder="选择场上位置"
                >
                  <el-option
                    v-for="item in positionList"
                    :key="item.uuid"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="球衣号码" prop="shirtNumber">
                <el-input
                  v-model="form.shirtNumber"
                  class="w380"
                  placeholder="请输入球衣号码"
                  maxlength="10" show-word-limit
                ></el-input>
              </el-form-item>

              <el-form-item
                label="是否首次考察该队员"
                prop="first"
                :rules="[{ required: true, message: '必填项' }]"
                class="yioks-switch"
              >
                <el-switch
                  v-model="form.first"
                  active-color="#4cd964"
                  active-text="是"
                  inactive-text="否"
                ></el-switch>
              </el-form-item>

              <template v-if="!form.first">
                <el-form-item label="已考察该球员次数" prop="scoutingNum">
                  <el-input
                    v-model="form.scoutingNum"
                    :disabled="form.first"
                    class="w380"
                    placeholder="请输入已考察该球员次数"
                    maxlength="10" show-word-limit
                  ></el-input>
                </el-form-item>
              </template>
              <el-form-item
                label="惯用脚"
                prop="preferredFoot"
                :rules="[{ required: true, message: '必填项' }]"
              >
                <el-select
                  v-model="form.preferredFoot"
                  class="w380"
                  placeholder="选择惯用脚"
                >
                  <el-option
                    v-for="item in preferredFootList"
                    :key="item.uuid"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>

              <div class="player-list-wrapper" v-for="(playerItem, index) in form.dataCompetitionInfos" :key="index">
                <div class="left-box">
                  <el-form-item label="比赛名称" :prop="`dataCompetitionInfos.${index}.competition`" :rules="[{ required: true, message: '必填项' }]">
                    <el-select v-model="playerItem.competition" class="w380" placeholder="选择比赛名称">
                      <el-option v-for="item in competitionList" :label="item.competitionName" :value="item.competitionName"></el-option>
                    </el-select>
                    <!--<el-input-->
                    <!--v-model="form.competition"-->
                    <!--class="w380"-->
                    <!--placeholder="输入比赛名称与场次"-->
                    <!--&gt;</el-input>-->
                  </el-form-item>

                  <template v-if="playerItem.competition === '其他'">
                    <el-form-item label="输入比赛名称" :prop="`dataCompetitionInfos.${index}.competition1`" :rules="[{ required: true, message: '必填项' }]">
                      <el-input v-model="playerItem.competition1" class="w380" placeholder="输入比赛名称" maxlength="100" show-word-limit></el-input>
                    </el-form-item>
                  </template>
                  <el-form-item label="比赛场次" :prop="`dataCompetitionInfos.${index}.competitionSession`">
                    <el-input v-model="playerItem.competitionSession" class="w380" placeholder="输入比赛场次" maxlength="100" show-word-limit></el-input>
                  </el-form-item>

                  <div style="display:flex;align-items:center">
                    <el-form-item label="比赛对阵" :prop="`dataCompetitionInfos.${index}.ourTeam`" :rules="[{ required: true, message: '必填项' }]">
                      <el-input v-model="playerItem.ourTeam" class="w150" placeholder="请输入我方队伍" maxlength="50" show-word-limit></el-input>
                    </el-form-item>
                    <span style="margin:0 20px 22px 20px;">VS</span>
                    <el-form-item label-width="0" :prop="`dataCompetitionInfos.${index}.otherTeam`" :rules="[{ required: true, message: '必填项' }]">
                      <el-input v-model="playerItem.otherTeam" class="w150" placeholder="请输入对方队伍" maxlength="50" show-word-limit></el-input>
                    </el-form-item>
                  </div>


                  <el-form-item label="比赛地点与场地" :prop="`dataCompetitionInfos.${index}.location`" :rules="[{ required: true, message: '必填项' }]">
                    <el-input v-model="playerItem.location" class="w380" placeholder="请输入比赛地点与场地" maxlength="100" show-word-limit></el-input>
                  </el-form-item>

                  <el-form-item label="比赛具体时间" :prop="`dataCompetitionInfos.${index}.kickTime`" :rules="[{ required: true, message: '必填项' }]">
                    <el-date-picker v-model="playerItem.kickTime" class="w380" align="right" type="date" value-format="timestamp" placeholder="选择日期"></el-date-picker>
                  </el-form-item>

                  <el-form-item label="比赛天气" :prop="`dataCompetitionInfos.${index}.weather`" :rules="[{ required: true, message: '必填项' }]">
                    <!--<el-input v-model="form.weather" class="w380" placeholder="请输入比赛天气状况"></el-input>-->
                    <el-select v-model="playerItem.weather" class="w380" placeholder="选择天气">
                      <el-option v-for="item in weatherList" :key="item.uuid" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="球队主要阵型" :prop="`dataCompetitionInfos.${index}.teamFormation`" :rules="[{ required: true, message: '必填项' }]">
                    <el-select v-model="playerItem.teamFormation" class="w380" placeholder="选择阵型">
                      <el-option v-for="item in teamFormationList" :key="item.uuid" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="上场时间（分钟）" :prop="`dataCompetitionInfos.${index}.playTime`">
                    <el-input v-model="playerItem.playTime" class="w380" placeholder="请输入上场时间" maxlength="10" show-word-limit></el-input>
                  </el-form-item>
                  <el-form-item label="表现情况（进球、助攻等）" :prop="`dataCompetitionInfos.${index}.performance`" :rules="[{ required: true, message: '必填项' }]">
                    <el-input v-model="playerItem.performance" class="w380" placeholder="请输入表现情况" maxlength="200" show-word-limit></el-input>
                  </el-form-item>
                  <el-form-item label="备注">
                    <el-input v-model="playerItem.remark" class="w380" placeholder="如有备注，可在此输入" maxlength="200" show-word-limit></el-input>
                  </el-form-item>
                </div>
                <div class="right-box">
                  <div v-if="!(form.dataCompetitionInfos.length === 1 && index == 0)">
                    <el-button type="danger" icon="el-icon-remove-outline" circle @click="handleDeletePlayerList(index)"></el-button>
                  </div>
                  <div style="margin-top: 10px">
                    <el-button type="success" icon="el-icon-circle-plus-outline" circle @click="handleAddPlayerList"></el-button>
                  </div>
                </div>
              </div>
              <el-form-item
                label="球探姓名"
                prop="scoutName"
                :rules="[{ required: true, message: '必填项' }]"
              >
                <el-input
                  v-model="form.scoutName"
                  class="w380"
                  disabled
                  placeholder="请输入球探姓名"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="球探所在单位"
                prop="scoutOrganization"
                :rules="[{ required: true, message: '必填项' }]"
              >
                <el-input
                  v-model="form.scoutOrganization"
                  class="w380"
                  placeholder="请输入球探所在单位"
                  maxlength="100" show-word-limit
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </vue-scroll>
        <yioks-tips
          :showTip="tipsFlag"
          tipMsg="请确认暂时保存并退出？"
          :loading="repeatSubmit"
          @callback="hideTipsDialog"
        ></yioks-tips>
        <yioks-tips
          :showTip="tipsFlagNext"
          tipMsg="请确认保存并进入下一步？"
          :loading="repeatNext"
          @callback="hideTipsDialogNext"
        ></yioks-tips>
        <yioks-tips
          :showTip="tipsFlagCancel"
          tipMsg="请确认放弃保存并返回吗？"
          :loading="repeatSubmitCancel"
          @callback="hideTipsDialogCancel"
        ></yioks-tips>
      </div>
    </div>

    <template v-slot:btn>
      <div class="btn_wrap">
        <el-button type="primary" @click="tempSave(false)">暂时保存</el-button>
        <el-button type="primary" @click="toNext(true)">下一步</el-button>
        <el-button type="danger" @click="toCancel">取消</el-button>
      </div>
    </template>
  </SubContent>
</template>

<script>
  import scout from "@/api/scout";
  import player from "@/api/player"; // getPlayerInfo获取球员信息
  import storage from "@/utils/storage";
  import {filterIdNumber} from "@/utils/yioks_filter";

  export default {
  name: "ScoutList",

  data() {
    return {
      tipsFlag: false,
      repeatSubmit: false,
      tipsFlagCancel: false,
      repeatSubmitCancel: false,
      repeatNext: false,
      tipsFlagNext: false,
      userRole: storage.get("userInfo").userRole,
      uuid: storage.get("userInfo").uuid,
      activeStep: 1,
      form: {
        scoutingTime: new Date().getTime(),
        playerName: "",
        playerIdNumber: "",
        playerBirthday: "",
        team: "",
        shirtNumber: "",
        first: false,
        scoutingNum: "",
        preferredFoot: "",
        scoutOrganization: "",
        scoutName: storage.get("userInfo").idName,
        dataType: "",
        position: "",
        dataCompetitionInfos:[
          {
            competition: "",
            competition1: "",
            competitionSession: "",
            ourTeam: "",
            otherTeam: "",
            teamFormation: "",
            playTime: "",
            performance: "",
            remark: "",
            location: "",
            kickTime: "",
            weather: "",
          } // //临时数据
        ],
      },

      positionList: [],
      competitionList: [],
      preferredFootList: [
        {
          name: "左脚",
          value: "左脚",
        },
        {
          name: "右脚",
          value: "右脚",
        },
        {
          name: "左右均衡",
          value: "左右均衡",
        },
      ],
      weatherList: [
        {
          name: "晴",
          value: "晴",
        },
        {
          name: "多云",
          value: "多云",
        },
        {
          name: "阴",
          value: "阴",
        },
        {
          name: "阵雨",
          value: "阵雨",
        },
        {
          name: "小雨",
          value: "小雨",
        },
        {
          name: "中雨",
          value: "中雨",
        },
        {
          name: "大雨",
          value: "大雨",
        },
        {
          name: "雨夹雪",
          value: "雨夹雪",
        },
        {
          name: "小雪",
          value: "小雪",
        },
        {
          name: "中雪",
          value: "中雪",
        },
        {
          name: "大雪",
          value: "大雪",
        },
      ],
      teamFormationList: [
        { name: "4-4-2", value: "4-4-2" },
        { name: "4-4-2（菱形中场）", value: "4-4-2（菱形中场）" },
        { name: "4-5-1", value: "4-5-1" },
        { name: "4-3-3", value: "4-3-3" },
        { name: "4-2-3-1", value: "4-2-3-1" },
        { name: "4-1-4-1", value: "4-1-4-1" },
        { name: "4-1-3-2", value: "4-1-3-2" },
        { name: "4-4-1-1", value: "4-4-1-1" },
        { name: "3-1-5-1", value: "3-1-5-1" },
        { name: "3-2-3-1-1", value: "3-2-3-1-1" },
        { name: "3-1-4-2", value: "3-1-4-2" },
        { name: "5-3-2", value: "5-3-2" },
        { name: "5-3-1-1", value: "5-3-1-1" },
        { name: "1-4-4-1", value: "1-4-4-1" },
        { name: "3-2-2-3", value: "3-2-2-3" },
        { name: "3-5-1-1", value: "3-5-1-1" },
        { name: "3-5-2", value: "3-5-2" },
        { name: "3-4-3", value: "3-4-3" },
        { name: "5-4-1", value: "5-4-1" },
        { name: "3-3-1（八人制）", value: "3-3-1（八人制）" },
        { name: "3-1-3（八人制）", value: "3-1-3（八人制）" },
        { name: "3-2-2（八人制）", value: "3-2-2（八人制）" },
        { name: "2-3-2（八人制）", value: "2-3-2（八人制）" },
        { name: "2-4-1（八人制）", value: "2-4-1（八人制）" },
        { name: "4-2-1（八人制）", value: "4-2-1（八人制）" },
        { name: "4-3-0（八人制）", value: "4-3-0（八人制）" },
        { name: "2-2（五人制）", value: "2-2（五人制）" },
        { name: "1-2-1（五人制）", value: "1-2-1（五人制）" },
        { name: "1-3（五人制）", value: "1-3（五人制）" },
        { name: "3-1（五人制）", value: "3-1（五人制）" },
      ],
      formRules: {
        shirtNumber: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入0-99内的球衣号码"));
              } else {
                if (/^[0-9]{1,2}$/.test(value)) {
                  callback();
                } else {
                  callback(new Error("请输入0-99内的球衣号码"));
                }
              }
            },
            trigger: "blur",
          },
        ],
        scoutingNum: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value !== 0 && !value) {
                callback(new Error("请输入数字"));
              } else {
                if (/^[0-9]+$/.test(value)) {
                  callback();
                } else {
                  callback(new Error("请输入数字"));
                }
              }
            },
            trigger: ["blur", "change"],
          },
        ],
        playTime: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入数字"));
              } else {
                if (/^[0-9]+$/.test(value)) {
                  callback();
                } else {
                  callback(new Error("请输入数字"));
                }
              }
            },
            trigger: "blur",
          },
        ],
      },
      scoutType: "player", // player：球员，goalkeeper：守门员
    };
  },

  components: {
    SubContent: () => import("@/components/layout/contentWithbtn"),
    "yioks-tips": () => import("@/components/YioksTip"),
  },

  computed: {
    playerUuid() {
      const uuid = this.$route.query.playerUuid || "";
      return uuid;
    },
    organUuid() {
      return this.$route.query.organUuid || "";
    },
    youthUuid() {
      return this.$route.query.youthUuid || "";
    },
    squadUuid() {
      return this.$route.query.squadUuid || "";
    },
    player_name() {
      return this.$route.query.player_name.trim() || "";
    },
    player_id_number() {
      return this.$route.query.player_id_number.trim().toUpperCase() || "";
    },
    position() {
      return this.$route.query.position || "";
    },
  },

  created() {
    this.loadPositionInfo();
    this.playerCompetitionList();
    this.getScoutOrganization();
    const isExit = this.position.indexOf("守门员") >= 0;
    this.$set(this.form, "position", this.position);
    // 存在守门员相关位置信息，则设置守门员内容
    if (this.position && isExit) {
      this.scoutType = "goalkeeper";
    this.$set(this.form, "dataType", "goalkeeper");
    } else {
      this.scoutType = "player";
    this.$set(this.form, "dataType", "player");
    }

    if(this.$route.query.oneUuid && !this.form.dataCompetitionInfos[0].competition){
      this.loadScoutDataInfo(this.$route.query.oneUuid);
    }


  },

  mounted() {
    if (this.playerUuid) {
      this.loadPlayerInfo();
    } else {
      this.setFormData();
    }
  },

  methods: {
    loadScoutDataInfo (uuid) {
        scout
        .getScoutDataInfo(uuid)
        .then((res) => {
          const { playerIdNumber,competitionInfos } = res;
          competitionInfos.forEach((item) => {
            delete item.id;
            delete item.uuid
            delete item.updatedAt;
            delete item.dataUuid;
            delete item.available
            delete item.createdAt
            delete item.performance
            delete item.playTime
            delete item.remark
          })
          this.$set(this.form, "dataCompetitionInfos", competitionInfos);
        })
        .catch((err) => {
          console.error(err)
        })
      },
    handleAddPlayerList() {
      let { dataCompetitionInfos } = this.form;
      console.log('dataCompetitionInfos before:', dataCompetitionInfos)
      dataCompetitionInfos.push({
        competition: "",
        competition1: "",
        competitionSession: "",
        ourTeam: "",
        otherTeam: "",
        teamFormation: "",
        playTime: "",
        performance: "",
        remark: "",
        location: "",
        kickTime: "",
        weather: "",
      });
      console.log('dataCompetitionInfos after:', dataCompetitionInfos)
      this.$set(this.form, "dataCompetitionInfos", dataCompetitionInfos);
    },
    handleDeletePlayerList(index) {
      let { dataCompetitionInfos } = this.form;
      console.log('dataCompetitionInfos before:', dataCompetitionInfos)
      dataCompetitionInfos.splice(index, 1);
      this.$set(this.form, "dataCompetitionInfos", dataCompetitionInfos);
      console.log('dataCompetitionInfos after:', dataCompetitionInfos)
    },
    /* 提交球探信息 */ ///
    submitData(status) {
      // 保存状态： dataStatus  incomplete  complete
      this.form.dataCompetitionInfos.map((item,index) => {
        if (item.competition === '其他'){
          this.form.dataCompetitionInfos[index].competition = item.competition1;
        }
      })
      const { playerName, playerBirthday, ...rest } = this.form;
      const playerUuid = this.playerUuid;
      const organUuid = this.organUuid;
      const youthUuid = this.youthUuid;
      const squadUuid = this.squadUuid;
      const aimData = {
        dataStatus: "incomplete",
        playerUuid,
        organUuid,
        youthUuid,
        squadUuid,
        ...rest,
      };
      return new Promise((resolve, reject) => {
        scout
          .postScoutInfo(aimData)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
            console.log(err);
          });
      });
    },
    playerCompetitionList(){
      scout
      .getScoutCompetition()
      .then((res) => {
        this.competitionList = res;
      })
      .catch((err) => {
        console.error("请求异常", err);
      });
    },
    /* 下一步 */
    toNext() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.tipsFlagNext = true;
        }else {
          this.$message.error("请完善所有带 * 的必填项");
        }
      });
    },
    hideTipsDialogNext(ok) {
      if (ok) {
        if (!this.repeatNext) {
          this.repeatNext = true;
          this.$refs["form"].validate((valid) => {
            if (valid) {
              this.form.dataCompetitionInfos.map((item,index) => {
                if (item.competition === '其他'){
                  this.form.dataCompetitionInfos[index].competition = item.competition1;
                }
              })
              if(this.form.first){
                this.form.scoutingNum = 0;
              }
              this.form.playerIdNumber = this.form.playerIdNumber.trim().toUpperCase();
              this.form.playerName = this.form.playerName.trim();
              const { playerName, playerBirthday, ...rest } = this.form;

              let aimData = {
                dataStatus: "complete",
                ...rest,
              };
              if (this.playerUuid) {
                const playerUuid = this.playerUuid;
                const organUuid = this.organUuid;
                const youthUuid = this.youthUuid;
                const squadUuid = this.squadUuid;
                aimData = Object.assign({}, aimData, {
                  playerUuid,
                  organUuid,
                  youthUuid,
                  squadUuid,
                });
              } else {
                const playerName = this.player_name;
                const playerIdNumber = this.player_id_number;
                aimData = Object.assign({}, aimData, {
                  playerName,
                  playerIdNumber,
                });
              }
              scout
                .postScoutInfo(aimData)
                .then((res) => {
                  const { uuid } = res;
                  this.repeatNext = false;
                  this.tipsFlagNext = false;
                  if (res.code) {
                    this.$message.error(res.msg);
                  } else {
                    this.$router.push({
                      name: "ScoutRate",
                      query: {
                        playerUuid: this.playerUuid,
                        dataUuid: uuid,
                        player_id_number: this.player_id_number,
                        player_name: this.player_name,
                        scoutType: this.scoutType,
                      },
                    });
                  }
                })
                .catch((err) => {
                  this.repeatNext = false;
                  this.tipsFlagNext = false;
                  console.log(err);
                });
            }
          });
        }
      } else {
        this.repeatNext = false;
        this.tipsFlagNext = false;
      }
    },
    /* 暂时保存 */
    tempSave(status) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.tipsFlag = true;
        }else {
          this.$message.error("请完善所有带 * 的必填项");
        }
      });
    },
    /* 暂时保存 */
    hideTipsDialog(ok) {
      if (ok) {
        if (!this.repeatSubmit) {
          this.repeatSubmit = true;
          this.$refs["form"].validate((valid) => {
            if (valid) {
              this.form.dataCompetitionInfos.map((item,index) => {
                if (item.competition === '其他'){
                  this.form.dataCompetitionInfos[index].competition = item.competition1;
                }
              })
              if(this.form.first){
                this.form.scoutingNum = 0;
              }
              this.form.playerIdNumber = this.form.playerIdNumber.trim().toUpperCase();
              this.form.playerName = this.form.playerName.trim();
              const { playerName, playerBirthday, ...rest } = this.form;
              let aimData = {
                dataStatus: "incomplete",
                ...rest,
              };
              if (this.playerUuid) {
                const playerUuid = this.playerUuid;
                const organUuid = this.organUuid;
                const youthUuid = this.youthUuid;
                const squadUuid = this.squadUuid;
                aimData = Object.assign({}, aimData, {
                  playerUuid,
                  organUuid,
                  youthUuid,
                  squadUuid,
                });
              } else {
                const playerName = this.player_name;
                const playerIdNumber = this.player_id_number;
                aimData = Object.assign({}, aimData, {
                  playerName,
                  playerIdNumber,
                });
              }

              scout
              .postScoutInfo(aimData)
              .then((res) => {
                this.repeatSubmit = false;
                this.tipsFlag = false;
                if (res.code) {
                  this.$message.error(res.msg);
                } else {
                  //  debugger
                  const { uuid } = res;
                  this.$router.push({
                    name: "ScoutList",
                  });
                }
              })
              .catch((err) => {
                this.repeatSubmit = false;
                this.tipsFlag = false;
                console.log(err);
              });
            }
          });
        }
      } else {
        this.repeatSubmit = false;
        this.tipsFlag = false;
      }
    },
    /* 取消 */
    toCancel() {
      this.tipsFlagCancel = true;
    },
    hideTipsDialogCancel(ok) {
      if (ok) {
        this.repeatSubmitCancel = false;
        this.tipsFlagCancel = false;
        this.$router.push({
          name: "ScoutList",
        });
      } else {
        this.repeatSubmitCancel = false;
        this.tipsFlagCancel = false;
      }
    },

    /* 获取球员信息 */
    loadPlayerInfo() {
      player
        .getPlayerInfo(this.playerUuid)
        .then((res) => {
          const { idName, idNumber, birthday } = res.user;
          if (idName) this.$set(this.form, "playerName", idName);
          if (birthday) this.$set(this.form, "playerBirthday", birthday);
          if (idNumber) this.$set(this.form, "playerIdNumber", idNumber);
        })
        .catch((err) => {
          console.error("请求异常", err);
        });
    },

    /* 获取球员信息 */
    getScoutOrganization() {
      scout
        .scoutPlayerDataScoutOrganization()
        .then((res) => {
          this.$set(this.form, "scoutOrganization", res)
        })
        .catch((err) => {
          console.error("请求异常", err);
        });
    },

    /* 填写内容 */
    setFormData() {
      // const moment = require('moment');
      this.$set(this.form, "playerName", this.player_name);
      if (this.player_id_number) {
        const playerBirthday = filterIdNumber(this.player_id_number, 0); //filterIdNumber
        const birthdayTimestamp = new Date(playerBirthday).getTime();
        this.$set(this.form, "playerBirthday", birthdayTimestamp);
        this.$set(this.form, "playerIdNumber", this.player_id_number);
      }
    },

    /* 获取position定位 */
    loadPositionInfo() {
      const params = {};
      player
        .allPositionList(params)
        .then((res) => {
          this.positionList = res.map((item) => ({
            uuid: item.uuid,
            name: item.playerPositionName,
          }));
        })
        .catch((err) => {
          console.error(res);
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.form_wrap
  padding 20px 20px 60px
  overflow hidden
  box-sizing border-box
  flex 1
  font-size 16px
  height 500px
.step-box
  margin-top 10px
.btn_wrap
  width 100%
  display flex
  justify-content center
.w380
  width 380px
.w150
  width 160px
.player-list-wrapper
  width 95%
  display flex
  justify-content space-around
  border-bottom 1px dashed #ccc
  border-top 1px dashed #ccc
  padding 20px 20px 0px 0px
  margin-bottom 20px
  .left-box
    width 100%
  .right-box
    width 40px
    display flex
    justify-content center
    flex-direction column
    align-items center
</style>

<style lang="stylus">
.page-content
  .el-steps--simple
    background-color rgba(0, 0, 0, 0)
  .el-form-item__label
    color #fff
    font-size 16px
</style>
<style lang="stylus">
@import '~@/assets/css/variable'
.yioks-switch
  .el-switch__label
    color $color_white
  .el-switch__label--left
    &.is-active
      color $color_white
  .el-switch__label--right
    &.is-active
      color $green_color
.yioks-switch-grey
  .el-switch__label
    color $grey_color
  .el-switch__label--left
    &.is-active
      color $grey_color
  .el-switch__label--right
    &.is-active
      color $green_color
</style>
